import React from 'react'
import { EmailOutlined } from '@mui/icons-material/'

import styles from './styles'
import AnimatedCheckmark from "../../../components/Animated/Checkmark"

const EmailSent = () => {
  const classes = styles()

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <EmailOutlined fontSize="inherit" />
          </div>
          <h1 className={classes.title}>Email enviado</h1>
          <h3 className={classes.subtitle}>
            Um email de recuperação foi enviado para sua conta. Lá você
            encontrará instruções para a recuperação do seu acesso.
          </h3>
        </div>
        <AnimatedCheckmark/>
      </div>  
    </div>
  )
}

export default EmailSent
